var _excluded = ["component", "color", "icon", "iconPlacement", "size", "small", "large", "fullWidth", "isCompact", "isLoading", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { buttonSmallStyles, buttonMediumStyles, buttonLargeStyles } from "@nib-components/theme";
import { Column, Columns, map } from "@nib/layout";
import Loader from "@nib/loader";
export var validSizes = ["small", "medium", "large"];
export var validColors = ["dark", "light", "destructive"];
export var validIconPlacement = ["left", "right"];
export var fullWidthStyling = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props.fullWidth !== undefined ? map(props.fullWidth, function (val) {
    if (val) {
      return "\n          width: 100%;\n        ";
    } else {
      return "width: auto;";
    }
  }) : "";
});
export var sizeStyling = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.small && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n    "])), buttonSmallStyles(props));
}, function (props) {
  return props.large && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", ";\n    "])), buttonLargeStyles(props));
}, function (props) {
  return props.size && !props.small && !props.large && map(props.size, function (val) {
    if (val === "small") {
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          ", ";\n        "])), buttonSmallStyles(props));
    } else if (val === "large") {
      return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          ", ";\n        "])), buttonLargeStyles(props));
    } else {
      return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          ", ";\n        "])), buttonMediumStyles(props));
    }
  });
});
export var StyledSpan = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  word-break: break-word;\n"])));
var StyledLineHeight = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  line-height: 0;\n"])));
var ShrinkColumn = styled(Column)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  flex-shrink: 1;\n"])));
var BaseButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  var component = props.component,
      _props$color = props.color,
      color = _props$color === void 0 ? "dark" : _props$color,
      Icon = props.icon,
      _props$iconPlacement = props.iconPlacement,
      iconPlacement = _props$iconPlacement === void 0 ? "right" : _props$iconPlacement,
      _props$size = props.size,
      size = _props$size === void 0 ? "medium" : _props$size,
      small = props.small,
      large = props.large,
      fullWidth = props.fullWidth,
      isCompact = props.isCompact,
      isLoading = props.isLoading,
      children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded);

  var Component = props.href ? "a" : component;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(Columns, {
    space: 2,
    verticalAlign: "center",
    align: "center"
  }, Icon && !isLoading && iconPlacement === "left" && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(StyledLineHeight, null, /*#__PURE__*/React.createElement(Icon, {
    size: "xs",
    fill: "currentColor"
  }))), isLoading && iconPlacement === "left" && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(StyledLineHeight, null, /*#__PURE__*/React.createElement(Loader, {
    size: "xs",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement(ShrinkColumn, {
    width: "content"
  }, /*#__PURE__*/React.createElement(StyledSpan, null, children)), Icon && !isLoading && iconPlacement === "right" && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(StyledLineHeight, null, /*#__PURE__*/React.createElement(Icon, {
    size: "xs",
    fill: "currentColor"
  }))), isLoading && iconPlacement === "right" && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(StyledLineHeight, null, /*#__PURE__*/React.createElement(Loader, {
    size: "xs",
    fill: "currentColor"
  })))));
});
export var buttonPropTypes = {
  // 'any' is required due to our use of GatsbyJS's Link component which doesn't fall under any defined PropType.
  component: PropTypes.any,
  color: PropTypes.oneOf(validColors).isRequired,
  icon: PropTypes.func,
  iconPlacement: PropTypes.oneOf(validIconPlacement),
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.oneOf(validSizes), PropTypes.shape({
    xs: PropTypes.oneOf(validSizes),
    sm: PropTypes.oneOf(validSizes),
    md: PropTypes.oneOf(validSizes),
    lg: PropTypes.oneOf(validSizes),
    xl: PropTypes.oneOf(validSizes),
    xxl: PropTypes.oneOf(validSizes),
    xxxl: PropTypes.oneOf(validSizes)
  })]),
  small: PropTypes.bool,
  large: PropTypes.bool,
  fullWidth: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    xxl: PropTypes.bool,
    xxxl: PropTypes.bool
  })]),
  isLoading: PropTypes.bool,
  href: PropTypes.string,
  children: PropTypes.node
};
export var buttonDefaultProps = {
  component: "button",
  color: "dark",
  iconPlacement: "right",
  selected: false,
  disabled: false,
  fullWidth: false,
  isLoading: false,
  size: "medium",
  small: false,
  large: false
};
BaseButton.defaultProps = buttonDefaultProps;
export default BaseButton;